import type {PublicMethodUtils} from '@wix/document-services-types'
import type {LocalEditorPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<LocalEditorPublicAPI> {
    return {
        methods: {
            localEditor: {
                save: publicMethodUtils.extensionPublicAPI.immediate('localEditor.save'),
                fullSave: publicMethodUtils.extensionPublicAPI.immediate('localEditor.fullSave'),
                documentFixesApplied: publicMethodUtils.extensionPublicAPI.immediate('localEditor.documentFixesApplied')
            }
        }
    }
}
